import { useEffect, useRef } from "react";

export const OTPInput = ({
  codeLength = 8,
  value,
  onChange,
  focus = true,
  setFocus,
}) => {
  const inputsRef = useRef([]);
  const firstInputRef = useRef(null);

  useEffect(() => {
    if (focus && firstInputRef.current) {
      firstInputRef.current.focus();
    }
  }, [focus]);

  const handleChange = (e, index) => {
    const val = e.target.value.replace(/\D/g, "").slice(0, 1);
    const newOtp = value.split("");
    newOtp[index] = val;
    const updated = newOtp.join("");
    onChange("otp", updated);

    // focus suivant
    if (val && index < codeLength - 1) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    const pasted = e.clipboardData
      .getData("text")
      .replace(/\D/g, "")
      .slice(0, codeLength);
    onChange("otp", pasted);
    pasted.split("").forEach((digit, i) => {
      if (inputsRef.current[i]) {
        inputsRef.current[i].value = digit;
      }
    });
    inputsRef.current[Math.min(pasted.length, codeLength - 1)]?.focus();
  };

  return (
    <div className="flex gap-2 justify-center">
      {[...Array(codeLength)].map((_, i) => (
        <input
          key={i}
          type="text"
          maxLength={1}
          defaultValue={value[i] || ""}
          onChange={(e) => handleChange(e, i)}
          onPaste={handlePaste}
          autoComplete="one-time-code"
          onBlur={() => {
            if (i === 0 && typeof setFocus === "function") {
              setFocus(false);
            }
          }}
          ref={(el) => {
            inputsRef.current[i] = el;
            if (i === 0) firstInputRef.current = el;
          }}
          className="w-10 h-12 text-center shadow focus:outline-none focus:ring-2 focus:ring-white font-nunito text-[14px] text-[#333]"
        />
      ))}
    </div>
  );
};